export default "__VITE_ASSET__CfPZzLgE__"